import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components"; 
import { Modal, Button } from "rsuite";
const Container = styled.svg`
  cursor: pointer;
  &:hover {
    fill: #1570ef;
    path {
      fill: #fff;
    }
  }
`;

function LoginPromptModal({ }) { 
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
 
  return (
    <>
      <Link 
        onClick={handleOpen}
        style={{
          textDecoration: "none",
          color: "#057AFF",
          cursor: "pointer",
        }}
      >
        請點我看說明
      </Link>
      <Modal open={open} onClose={handleClose} backdrop="static">
        <Modal.Header>
          <Modal.Title>帳號申請說明</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          聯新國際醫院區域聯防轉診平台，以提升取栓轉診時效與品質為目標，敬請各院醫療團隊加入。申請帳號相關問題，請電洽聯新國際醫院 03-2831386(蔡瑋芳)。另請注意，當您取得帳號且透過LINE官方帳號啟用，即表示同意本網站之
          <Link to={'/PrivacyPolicy'}>LINE使用宣告及隱私權政策</Link>。
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={handleClose}
            appearance="primary"
          >
            我知道了
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default LoginPromptModal;
